import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { captureTokenFromUrl } from './services/authTokenService'

// Capture auth token from URL fragment before anything else renders.
// This must run synchronously before React mounts so the token is available.
captureTokenFromUrl();

// Initialize theme based on environment
const theme = import.meta.env.VITE_THEME || 'light';
if (theme !== 'light') {
  document.documentElement.setAttribute('data-theme', theme);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)